
<div>
    <div class="cargando-jardin"><mat-spinner *ngIf="cargando"></mat-spinner></div>
    <div *ngIf="!cargando"> 
        
        <!-- <div class="sidebar" >
            <div class="sidebar-brand profile">
                <div class="image-cropper">
                    <img src="../../../assets/avatar.png" alt="avatar" class="profile-pic">
                </div>
            </div>
            Secciones-del-tablero
            <div class="sidebar-menu">
                <ul>
                    <li>
                        <a (click)="menuVisible('inicio')" [className]="menuMostrar==='inicio'? 'active' : ''">
                            <div [className]="menuMostrar==='inicio'? 'icon-menu icon-home' : 'icon-menu'"><i class="fas fa-home"></i></div>
                            <span class="menu-text">INICIO</span>
                        </a>
                    </li>
                    <li>
                        <a (click)="menuVisible('disponibilidad')" [className]="menuMostrar==='disponibilidad'? 'active' : ''">
                            <div [className]="menuMostrar==='disponibilidad'? 'icon-menu icon-identity' : 'icon-menu'"><i class="fas fa-calendar-check"></i></div>
                            <span class="menu-text" >DISPONIBILIDAD</span>
                        </a>
                    </li>
                    <li>
                        <a (click)="menuVisible('aula-virtual')" [className]="menuMostrar==='aula-virtual'? 'active' : ''">
                            <div [className]="menuMostrar==='aula-virtual'? 'icon-menu icon-aula-virtual' : 'icon-menu'"><i class="fas fa-thumbs-up"></i></div>
                            <span class="menu-text">AULA VIRTUAL</span>
                        </a>
                    </li>
                    <li>
                        <a (click)="menuVisible('proyecto-educativo')" [className]="menuMostrar==='proyecto-educativo'? 'active' : ''">
                            <div class="icon-menu" [className]="menuMostrar==='proyecto-educativo'? 'icon-menu icon-proyecto-educativo' : 'icon-menu'"><i class="fas fa-folder-open"></i></div>
                            <span class="menu-text">PROYECTO EDUCATIVO</span>
                        </a>
                    </li>          
                   
                </ul>
            </div> 

             <div class="sidebar-brand">
                <button (click)="cerrarSesion()" type="button" class="btn btn-light btn-logout"><i class="fas fa-power-off"></i> Salir</button>
            </div> 
        </div> -->


            <main class="mainTutor">
                <app-inicio-tutor *ngIf="menuMostrar==='inicio'"></app-inicio-tutor>  
                <app-disponibilidad  *ngIf="menuMostrar==='disponibilidad'"></app-disponibilidad >  
                <app-capacitacion-tutor-moodle  *ngIf="menuMostrar==='capacitacion'"></app-capacitacion-tutor-moodle>      
                    
            </main>

    <div> 
</div>


<footer class="footer mt-auto py-3 footerTutor" style="z-index: 101;position: fixed;bottom: 0;left: 0;right: 0;">
    <div style="margin-left: 100px;margin-right: 100px;">
        <div class="row">
            <div class="col-sm-3">
                <p style="text-align: left;
                font: normal normal bold 14px/18px Montserrat;
                letter-spacing: 0px;
                color: #FFFFFF;
                text-transform: uppercase;
                padding-top: 10px;
                opacity: 1;">MODELO DE GESTIÓN DE LA CALIDAD</p>
                <p style="text-align: left;
                font: normal normal bold 14px/18px Montserrat;
                letter-spacing: 0px;
                color: #FFFFFF;
                text-transform: uppercase;
                opacity: 1;">DE LA EDUCACIÓN PARVULARIA</p>
            </div>

            <div  class="col-sm-5" style="text-align: right;">
                <button type="button" class="btn btn-light btn-menu" (click)="menuVisible('inicio')" [className]="menuMostrar==='inicio'? 'btn-menu-active' : 'btn-menu'" >                    
                    <img src="../../../assets/icons/inicio_off@2x.png" style="width: 24px;margin-right: 10px;">
                    <span style="color: #FFFFFF;">INICIO</span>
                </button>
                <button type="button" class="btn btn-light btn-menu" (click)="menuVisible('disponibilidad')" [className]="menuMostrar==='disponibilidad'? 'btn-menu-active' : 'btn-menu'" >                    
                    <img src="../../../assets/icons/inicio_off@2x.png" style="width: 24px;margin-right: 10px;">
                    <span style="color: #FFFFFF;">DISPONIBILIDAD</span>
                </button>
                <button type="button" class="btn btn-light btn-menu" (click)="menuVisible('capacitacion')" [className]="menuMostrar==='capacitacion'? 'btn-menu-active' : 'btn-menu'" >                    
                    <img src="../../../assets/icons/inicio_off@2x.png" style="width: 24px;margin-right: 10px;">
                    <span style="color: #FFFFFF;">CAPACITACIÓN</span>
                </button>
            </div>


            <div  class="col-sm-3" style="text-align: right;">
                <div class="row">
                    <div class="col-sm-12">
                        <p style="color: #FFFFFF;display: inline-block;">Bienvenida,</p>
                        <ng-template #popContent >
                            <button (click)="cambiarPass()" type="button" class="btn btn-light btn-popover"><i class="fas fa-key"></i> CAMBIAR CLAVE</button>
                            <button (click)="cambiarFoto()" type="button" class="btn btn-light btn-popover"><i class="fas fa-portrait"></i> CAMBIAR FOTO</button>
                            <button (click)="cerrarSesion()" type="button" class="btn btn-light btn-popover"><i class="fas fa-power-off"></i> SALIR</button>
                        </ng-template>
                        <ng-template #popTitle>{{tutor.nombres}}  {{tutor.apellidos}} <br> {{tutor.correo}} </ng-template>
                        <button  class="image-cropper" placement="top" [ngbPopover]="popContent" [popoverTitle]="popTitle">
                                <img [src]="urlProfile" alt="avatar" id="improfile" class="profile-pic" >  
                        </button>
                        <p style="color: #FFFFFF;display: inline-block;margin: 0px 5px;">{{tutor.nombres}}  {{tutor.apellidos}}</p>
                    </div>
                </div>
               
            </div>

            <div  class="col-sm-1" style="text-align: right;">
                
                    <img src="../../../assets/icons/JUNJI__JUNJI-logo.svg" style="width: 100px;margin-right: 10px;">

            </div>
        </div>
    </div>
</footer>
  